import { render, staticRenderFns } from "./SportModal.vue?vue&type=template&id=2516adff&"
import script from "./SportModal.vue?vue&type=script&lang=js&"
export * from "./SportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports